// Utils
import useDateTimeFormat from '../../../hooks/useDateTimeFormat';

// Types
import { CollectionItemTypes, CollectionMethod } from '../../../types/CollectionItemTypes';
import { CollectionMetaAndDetails } from '../../../constants/Constants';

// Components
import { OverviewCard, OverviewGrid, GridField } from '../../common/OverviewCard/OverviewCard';

interface CollectionStageProps {
  details: any;
}

const CollectionStage = ({ details }: CollectionStageProps) => {
  const { toStandardDate, withTimeMode } = useDateTimeFormat();
  const collectItems = details.configuration.collect;
  const collectNames = collectItems && collectItems.length > 0 ? collectItems.map((item: number) => CollectionItemTypes[item]).join(' | ') : '-';

  const collectMethods = details.configuration.methods;
  const collectMethod = collectMethods && collectMethods.length > 0 ? collectMethods.map((item: number) => CollectionMethod[item]).join(' | ') : '-';

  const rows: GridField[][] = [
    [
      { label: CollectionMetaAndDetails.station, value: details.targetedStation?.iataCode ?? '-' },
      { label: CollectionMetaAndDetails.itemTypes, value: collectNames },
      { label: CollectionMetaAndDetails.noOfItems, value: details.count ?? '-' },
      { label: CollectionMetaAndDetails.collectionMethod, value: collectMethod },
    ],
    [
      { label: withTimeMode(CollectionMetaAndDetails.createdAt), value: toStandardDate(details.createdDateTime) },
      { label: withTimeMode(CollectionMetaAndDetails.updatedOn), value: toStandardDate(details.modifiedDateTime) },
    ],
  ];

  return (
    <OverviewCard
      title='Collection Details'
      headerRight={
        <>
          <span style={{ color: '#6b7280' }}>{CollectionMetaAndDetails.collectionName}:</span>
          <strong style={{ color: '#1f2229' }}>{details.name ?? '-'}</strong>
        </>
      }
      className='extra-margin'
    >
      <OverviewGrid columns={4} rows={rows} />
    </OverviewCard>
  );
};

export default CollectionStage;
